class HfgHomeSlideshow extends HTMLElement {
  connectedCallback() {
    if (this.ready) {
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.visibilityHandler();
      return;
    }
    this.ready = true;
    const slides = [...this.querySelectorAll('[data-slide]')];
    let index = 0;
    let hovering = false;
    const schedule = () => {
      clearInterval(this.timer);
      if (this.isConnected && !hovering && !document.hidden && !this.matches(':focus-within')) {
        this.timer = setInterval(() => show(index + 1), 5000);
      }
    };
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.querySelector('[data-status]').textContent = `Slide ${index + 1} of ${slides.length}`;
      schedule();
    };
    this.addEventListener('mouseenter', () => { hovering = true; schedule(); });
    this.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    this.addEventListener('focusin', schedule);
    this.addEventListener('focusout', () => setTimeout(schedule, 0));
    this.visibilityHandler = schedule;
    document.addEventListener('visibilitychange', schedule);
    schedule();
    let start;
    this.addEventListener('touchstart', (event) => {
      start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    this.addEventListener('touchend', (event) => {
      if (!start) return;
      const dx = event.changedTouches[0].clientX - start.x;
      const dy = event.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      start = null;
    }, { passive: true });
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }
}
if (!customElements.get('hfg-home-slideshow')) customElements.define('hfg-home-slideshow', HfgHomeSlideshow);
